import { render, staticRenderFns } from "./addPeople.vue?vue&type=template&id=aac0fee8&"
import script from "./addPeople.vue?vue&type=script&lang=js&"
export * from "./addPeople.vue?vue&type=script&lang=js&"
import style0 from "./addPeople.vue?vue&type=style&index=0&id=aac0fee8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports